"use strict";

exports.DexScreenerError = void 0;
var _sdkTypes = require("../sdk-types");
class DexScreenerError extends _sdkTypes.SdkError {
  constructor(msg, context) {
    super(msg, 'DexScreenerError', context);
  }
}
exports.DexScreenerError = DexScreenerError;